import {
  FraudConfigResponse,
  FraudConfigResponseSchema,
  UpdateFraudConfigRequest,
  UpdateFraudConfigRequestSchema,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

export const SecurityService = {
  getConfig: async (): Promise<FraudConfigResponse> => {
    const token = await AuthService.getShopifyToken();
    if (!token) throw new Error("No Shopify token available");

    const response = await fetch(`${API_BASE_URL}/admin/fraud-config`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load security config: ${response.statusText}`);
    }

    const data = await response.json();
    return FraudConfigResponseSchema.parse(data);
  },

  updateConfig: async (
    data: UpdateFraudConfigRequest
  ): Promise<FraudConfigResponse> => {
    const token = await AuthService.getShopifyToken();
    if (!token) throw new Error("No Shopify token available");

    const validPayload = UpdateFraudConfigRequestSchema.parse(data);

    const response = await fetch(`${API_BASE_URL}/admin/fraud-config`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(validPayload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Failed to save security config: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return FraudConfigResponseSchema.parse(result);
  },
};
